import Rating from "../../../../pages/home/Rating";
export default function HotelName({ children, name, rating = 5 }) {
	return (
		<>
			<h1 className="text-darkGray font-outfit font-medium text-[19px] leading-[156%] tracking-[0.01em] hover:text-[#FE4747] line-clamp-2 min-h-[62px] overflow-hidden w-[80%]">
				{name}
			</h1>
			<Rating rating={rating} />
		</>
	);
}
